import axios from 'axios';
import { CUSTOMER_API_URL } from '../../constants';
import { SubscriptionApiType } from '../../types/api/SubscriptionApiType';

/**
 * 定期契約を getSubscription で取得する（送信直前の状態確認用）。
 * useSubscriptionDetail の fetch と同様にラインを variantId でソートする。
 */
export async function fetchSubscriptionContract(
  token: string,
  subscriptionId: string
): Promise<SubscriptionApiType | null> {
  try {
    const response = await axios.post<SubscriptionApiType>(
      `${CUSTOMER_API_URL}?action=getSubscription`,
      { subscriptionId },
      { headers: { Authorization: token } }
    );
    const data = response.data;
    if (!data?.subscriptionContractId) return null;
    if (data.subscriptionLines?.length) {
      data.subscriptionLines = [...data.subscriptionLines].sort((a, b) =>
        (a.variantId ?? '').localeCompare(b.variantId ?? '')
      );
    }
    return data;
  } catch {
    return null;
  }
}
